<template>
  <UiDropdown
    ref="dropdown"
    custom-design="w-auto overflow-y-auto"
    @shown="dropdownShown()"
    @hidden="dropdownHidden()"
  >
    <template #trigger>
      <UiSearchFilterSelect
        :open="dropdown?.isOpen"
        :active="props.active"
        :aria-button-label="props.labelDropdown"
        @click="dropdown.toggle()"
      >
        <slot name="trigger" />
      </UiSearchFilterSelect>
    </template>
    <template #default>
      <slot name="default" />
    </template>
    <template #foot>
      <div class="flex items-center">
        <div role="button" tabindex="0" class="cursor-pointer underline text-sm" @click="emit('reset')" @keydown.enter="emit('reset')">
          {{ t('delete') }}
        </div>
      </div>
      <div class="place-self-end">
        <UiButton @click="dropdown.hide()" @keydown.enter="dropdown.hide()">
          {{ resultsCount }} {{ t('results') }}
        </UiButton>
      </div>
    </template>
  </UiDropdown>
</template>

<script setup>
const emit = defineEmits(['reset', 'shown', 'hidden'])

const dropdown = ref()

const props = defineProps({
  resultsCount: {
    type: Number,
    default: 0
  },
  labelDropdown: {
    type: [String, Number, Boolean, Array],
    default: false
  },
  active: {
    type: Boolean,
    default: false
  }
})

const t = useTranslations('SearchFilterDropdown').translate

const dropdownShown = () => {
  emit('shown')
}

const dropdownHidden = () => {
  emit('hidden')
}
</script>
